(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('complementAirCrews', {
                parent: 'app',
                url: '/complementAirCrew/list',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/flightControl/airCrew/complementAirCrew/complementAirCrews.html',
                        controller: 'complementAirCrewsCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabAdminFlights': ['tabService', function(tabService){
                                return tabService.getTabOccupationCrew('complementAirCrews')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['aircrew']);
                            }],
                            'complementAirCrews': ['complementAirCrewService','$stateParams', function (complementAirCrewService,$stateParams) {
                                return complementAirCrewService.getPageComplementAirCrews($stateParams.page, $stateParams.size)
                            }]
                        }
                    }
                }
            })
            .state('complementAirCrewNew', {
                parent: 'app',
                url: '/complementAirCrew/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/flightControl/airCrew/complementAirCrew/complementAirCrewNew.html',
                        controller: 'complementAirCrewNewCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabAdminFlights': ['tabService', function(tabService){
                                return tabService.getTabOccupationCrew('complementAirCrews')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['aircrew','structureSeatMap']);
                            }],
                            'complementAirCrewCharges': ['assignAirCrewService', function (assignAirCrewService) {
                                return assignAirCrewService.getCrewByCrewType("1", "1")
                            }],
                            'occupationComplementAirCrewList': ['complementAirCrewService', function (complementAirCrewService) {
                                return complementAirCrewService.getOccupationCrewListComplement()
                            }]
                        }
                    }
                }
            })
            .state('complementAirCrewEdit', {
                parent: 'app',
                url: '/complementAirCrew/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/flightControl/airCrew/complementAirCrew/complementAirCrewEdit.html',
                        controller: 'complementAirCrewEditCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabAdminFlights': ['tabService', function(tabService){
                                return tabService.getTabOccupationCrew('complementAirCrews')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['aircrew','structureSeatMap']);
                            }],
                            'complementAirCrew': ['complementAirCrewService', '$stateParams', function (complementAirCrewService, $stateParams) {
                                return complementAirCrewService.getComplementAirCrewById($stateParams.id)
                            }],
                            'occupationComplementAirCrewList': ['complementAirCrewService', function (complementAirCrewService) {
                                return complementAirCrewService.getOccupationCrewListComplement()
                            }]
                        }
                    }
                }
            })
            .state('complementAirCrewDelete', {
                parent: 'complementAirCrews',
                url: '/complementAirCrew/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/flightControl/airCrew/complementAirCrew/complementAirCrewDelete.html',
                        controller: 'complementAirCrewDeleteCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['aircrew']);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('complementAirCrews', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();

